import createApi from './api';

export default class PayForPerformanceTiersSettingsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/p4p',
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async getP4PTiers() {
    return this.api.get('get-config');
  }

  async updateP4PTiers(params) {
    return this.api.post('set-config', params);
  }
}
